import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import {IpvalidationService} from './ipvalidation.service'
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IpCheckGuard implements CanActivate {
  constructor(private ipService:IpvalidationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {

  if (route.routeConfig?.path === 'PasswordChangeRequest') {
    return of(true);
  }

  return this.ipService.checkIPValidity().pipe(
    tap(valid => {
      if (!valid) {
        this.router.navigate(['/AccessDenied']);
      }
    })
  );
}
}
 